import React, {  useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import AddHeader from '../components/AddHeader/AddHeader';
import FormContainer from '../components/FormContainer/FormContainer';
import { useNavigate } from 'react-router-dom';
import { addBanner } from '../hooks/Banners';

function AddBanner() {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { currentLocal } = useSelector((state) => state.currentLocal);
          const {list:products } = useSelector((state) => state.products);
  
  const [product, setProduct] = useState('')
  const [images, setImages] = useState([]);
  const [imagePreviews, setImagePreviews] = useState([]);
  const [loading, setLoading] = useState(false)
  const [activeState, setactiveState] = useState(0)

  const productssOptions=products.map((item)=>({
        value: item?.id, label: currentLocal.language === "العربيه" ? item?.name_ar : item?.name_en

  }))



    const handleImageChange = (e) => {
    const files = Array.from(e.target.files);
    if (files.length === 0) return;

    setImages((prev) => [...prev, ...files]);

    const previews = files.map((file) => URL.createObjectURL(file));
    setImagePreviews((prev) => [...prev, ...previews]);
  };

  const inputs = activeState==1?[
    { id: 1, name: currentLocal.home.productName, value: product, grid: 6, onChanegFunction: (selectedlecturer) => setProduct(selectedlecturer), type: "select", options: productssOptions },
        { id: 2, name: currentLocal.home.images, onChanegFunction: handleImageChange, grid: 6, type: "file", multiple: true, accept: "image/*" },

  ]:[
        { id: 2, name: currentLocal.home.images, onChanegFunction: handleImageChange, grid: 6, type: "file", multiple: true, accept: "image/*" },

  ]
  const handleSubmit = () => {
                  const formData = new FormData();
                  console.log(activeState);
                  
                  if(activeState==1){
      
                    formData.append('product_id', product?.value)
                  }
                    if (images) {
      images.forEach((image, index) => {
        formData.append(`images[${index}]`, image);
      })
    }

    setLoading(true)

    dispatch(addBanner(formData))
      .unwrap()
      .then(() => {
        setLoading(false)
        alert(currentLocal.home.addedsuccessfully)
        navigate("/dashboard/banners")

      })
      .catch((err) => {
        setLoading(false)

      });
  }
  return (
    <div className='outlit_bg'>
      <AddHeader
        title={currentLocal.home.addbanner}
      />
      <div className='d-flex align-items-center mx-4 mb-4'>
        <button className={activeState==0?'mx-1 rounded bg-black text-white border-black px-2 py-1':'mx-1 rounded bg-white px-2 py-1'}onClick={()=>setactiveState(0)}>{currentLocal.home.generalbanner}</button>
            <button className={activeState==1?'mx-1 rounded bg-black text-white border-black px-2 py-1':'mx-1 rounded bg-white px-2 py-1'}onClick={()=>setactiveState(1)}>{currentLocal.home.Productbanner}</button>
      </div>
      <div className='body_container mx-4'  >
        <p className='border-bottom pb-3'>{currentLocal.home.addbanner}</p>
        <FormContainer
          inputs={inputs}
          btnText={currentLocal.home.add}
          handleSubmit={handleSubmit}
          loading={loading}
          imagePreview={imagePreviews}
        />
      </div>
    </div>
  )
}

export default AddBanner


